// React
import React from "react";

import Numeral from 'numeral';

// Stores
import { CurrencyStore } from '../../Stores';

import './dashboard-flex.css';
import './dashboard.css';

const Holding = ({name, ticker, quoteCurrency, pnl, change, position, quantity, light}) => {

    const currencyName = name === null ? CurrencyStore.getCoinName(ticker) : name;
    const currencySymbol = CurrencyStore.getCurrencySymbol(quoteCurrency);

    const quoteDecimals = CurrencyStore.getFormat(quoteCurrency);
    const holdingDecimals = CurrencyStore.getFormat(ticker);

    const holdingClass = light == null || light === false ? 'flex-panel' : 'flex-panel lighter';

    return (
        <div className={holdingClass} key={ticker}>

            <div className="child-row">

                <div className="row-box left">

                    <div>
                        { currencyName }
                    </div>

                    <div className="italic lowlight"> 
                        { ticker }
                    </div>

                </div>

                <div className="row-box right">

                    <div>
                        <span className="right-pad">{ currencySymbol }</span>
                        { Numeral(pnl).format(quoteDecimals) }
                        <i className={ pnl > 0 ? 'icon-arrow-up8 green-text left-pad arrow hover-up' : 'icon-arrow-down8 red-text left-pad arrow hover-down'}></i>
                    </div>

                    <div className="lowlight"> 
                        { Numeral(change * 100).format(CurrencyStore.getCurrencyFormat()) }
                        <span className="left-pad">%</span>
                    </div>

                </div>

                {/*-------- Value and Percentage --------*/}
                <div className="row-box right" style={{width:'115px'}}>

                    <div>
                        <span className="right-pad">{ currencySymbol }</span>
                        { Numeral(position).format(quoteDecimals) }
                    </div>
                    
                    <div className="lowlight">
                        { Numeral(quantity).format(holdingDecimals) }
                    </div>

                </div>

            </div>

        </div>
    );

};

export default Holding;


// WEBPACK FOOTER //
// ./src/Views/Dashboard/Holding.js